/**
 * 共通受付照会API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 電気高圧・特高情報
 */
export interface Sgkb575aResElecKoatsutokkoInfo {
    /** 
     * 設備情報変更有無区分：半角英数混在
     */
    setsubiHenkoUmuKbn?: string;
    /** 
     * 設備情報変更有無区分名称：全角半角混在
     */
    setsubiHenkoUmuKbnMeisho?: string;
    /** 
     * 需要者窓口所属：全角文字
     */
    dmndrdAttach?: string;
    /** 
     * 需要者窓口連絡先氏名：全角文字
     */
    madoguchiRenrakuShimei?: string;
    /** 
     * 需要者窓口電話番号：電話番号(ハイフンと数値含む)
     */
    dmndrdTelno?: string;
    /** 
     * 主任技術者所属：全角文字
     */
    shuninGijutsushaShozoku?: string;
    /** 
     * 主任技術者連絡先氏名：全角文字
     */
    shuninRenrakuShimei?: string;
    /** 
     * 主任技術者電話番号：電話番号(ハイフンと数値含む)
     */
    shuninTelno?: string;
    /** 
     * 中継店申込者名：全角文字
     */
    relaypointSrnper?: string;
    /** 
     * 中継店申込者連絡先：電話番号(ハイフンと数値含む)
     */
    relaypointSrnperCnctto?: string;
}
